//100vh Fix
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

function focus() {
  $('#header_search_input').focus();
}

$(document).ready(function(){

  //Headroom
  /*$("#sticky_header").headroom({
    offset: {
        up: 100,
        down: 100
    }
  });*/

  //Scroll Links
  $('a.scroll').click(function(e){
    e.preventDefault();
    var $target = $(this).attr('href');
    $([document.documentElement, document.body]).animate({
        scrollTop: $($target).offset().top
    }, 1000);
  })

  //Age Gate
  if ( Cookies.get('agegate-accept') ) {

  } else {
    if ( $('html').hasClass('shopify-design-mode')) {

    } else {
      $('#age_gate').removeClass('closed');
      $('.accept_agegate').click(function(e){
        e.preventDefault();
        $(this).parents('.modal_parent').addClass('closed');
        Cookies.set('agegate-accept', true, { expires: 1 })
      });
    }
  }

  //Subscribe Popup
  if ( Cookies.get('seen-popup') ) {

  } else {
    setTimeout(function(){
      Cookies.set('seen-popup', true, { expires: 1 })
      $('#subscribe_popup').removeClass('closed');
      $('.close_modal').click(function(e){
        e.preventDefault();
        $(this).parents('.modal_parent').addClass('closed');
      });
    },25000);
  }
  
  //Mob Menu Submenu Controls
  $('#mob_menu li.has_submenu a.open_submenu').click(function(e){
    e.preventDefault();
    $(this).parents('.has_submenu').find('.submenu').addClass('active');
  });
  $('#mob_menu .submenu .go_back').click(function(e){
    e.preventDefault();
    $(this).parents('.submenu').removeClass('active');
  });
  $('.toggle_menu').click(function(e){
    e.preventDefault();
    $('body').toggleClass('mob_menu_open');
    $('#mob_menu .submenu').removeClass('active');
  });

  $('.has_sub_submenu').click(function(){
    $(this).toggleClass('open');
    $(this).next('.sub_submenu').toggleClass('open');
  })

  //Filters 
  $('.toggle_filters').click(function(e){
    e.preventDefault();
    console.log('i work');
    $('.filters_box').toggleClass('open');
  });

  //Product Tabs
  $('.tab .title').click(function(){
    $(this).parents('.tab').toggleClass('open');
  });

  //Product Slideswhow
  const productSwiper = new Swiper('.product_images_mobile.with-swiper .swiper-container', {
    loop: true,
    autoHeight: true,
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  //Press Carousel
  const pressSwiper = new Swiper('.press_carousel .swiper-container', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 50,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    autoplay: {
       delay: 5000,
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 50
      }
    }
  });

  //Top Bar Slideshow
  const topbarSwiper = new Swiper('#top_bar.with-swiper .swiper-container', {
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    }
  });

  //Quantity Buttons on Add to Cart
  $('.qty_wrap .plus').click(function(){
    var $number = parseInt($(this).parents('.qty_wrap').find('input').val()) + 1;
    $(this).parents('.qty_wrap').find('input').val($number);
  })
  $('.qty_wrap .minus').click(function(){
    var $number = parseInt($(this).parents('.qty_wrap').find('input').val()) - 1;
    if ( $number > 0 ) {
      $(this).parents('.qty_wrap').find('input').val($number);
    }
  })

  //Cart Drawer
  $('.toggle_cart').click(function(e){
    e.preventDefault();
    $('#side_cart, #cart_mask').toggleClass('open');
  });

  //Ajax Remove Button
  $('body').on('click','.remove_link',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']=0',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Ajax Change Quantity in Cart
  $('body').on('click','.side_cart_quantity',function(event){
    event.preventDefault();
    var $quantity = $(this).attr('data-qty');
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']='+$quantity+'',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Order Notes
  $('body').on('focusout','#CartNote0',function(event){
    event.preventDefault();
    var $cartNote = $('#CartNote0').val();
    $('#cart_contents').addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {note: $cartNote},
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
      }
    });
  });

  //Search
  $('.toggle_search').click(function(e){
    e.preventDefault();
    $('#search_mask, #search_bar').toggleClass('open');
    setTimeout(function(){
      if ( $('#search_bar').hasClass('open') ) {
        focus();
      }
    },200);
  });

  //Predictive Search
  $('#header_search_input').keyup(function(){
    var q = $('#header_search_input').val();
    var b = '&resources[type]=product'

    if ( q == '') {
      $("#searchResults").empty();
      $('.full_results').hide();
    } else {
      $.ajax('/search/suggest.json?q=' + q + b,{
        type: 'GET',
        dataType: 'json', // added data type
        success: function(response) {
            var productSuggestions = response.resources.results.products;
            if (productSuggestions.length > 0) {
              $("#searchResults").empty()
              $(productSuggestions).each(function() {
                if (this.featured_image.url) {
                  $("#searchResults").append(
                  '<li><a href="' + this.url + '"><div class="image"><img src="' + this.featured_image.url + '"/></div><div><p>'+ this.title +'</p></div></a<</li>'
                  );
                } else {
                   $("#searchResults").append(
                  '<li><a href="' + this.url + '"><div class="image"><img src="https://cdn.shopify.com/s/files/1/0680/5327/0827/t/2/assets/placeholder_100x100.png?v=64562696578910168471677067703"/></div><div><p>'+ this.title +'</p></div></a<</li>'
                );
                }
               
              });
              $('.full_results').show();
            } else {
              $('.full_results').hide();
              $("#searchResults").empty().append(
                  '<li><p class="text-small">No Results Found</p></li>'
              );
            }
        }
      });
    }
  });

  //View Full Results
  $('.full_results a').click(function(e){
    e.preventDefault();
    $('#search_bar form').submit();
  })

  //Wrap Blog videos and images in class
  $(".article_content iframe").wrap("<div class='article_video'/>");
  $(".article_content img").wrap("<div class='article_image'/>");



  //Wrap Big Tables in wrapper on pages like Truck Size Guide
  $('.page_content table').wrap("<div class='table_wrap'></div>");

  //FAQ
  $('.question_wrap .question').click(function(){
    $(this).parent().toggleClass('open');
  })

  //If URL has Query
  var URL = location.search;
  if(URL.indexOf("filter") > -1){
  }else{
      $('#clear_all_facets').hide();
  }

  

});



